import { SelectionChangedEvent } from "ag-grid-community";
import { BillingTypeMappingEntity } from "domain/entity/BillingTypeMapping/BillingTypeMappingEntity";
import _ from "lodash";
import { INITIAL_BILLING_TYPE_MAPPING_COL_DEF } from "presentation/constant/BillingTypeMapping/BillingTypeMappingColumnDefinition";
import { useBillingTypeMappingVM } from "presentation/hook/BillingTypeMapping/useBillingTypeMappingVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useBillingTypeMappingTracked } from "presentation/store/BillingTypeMapping/BillingTypeMappingProvider";
import RightClickMenuWithMoveAfter from "presentation/view/components/NbisRightClickMenu/RightClickMenuWithMoveAfter";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { createRef, memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Loader } from "veronica-ui-component/dist/component/core";
const BillingTypeMappingTablePanel = () => {
    const gridRef: any = useRef(null);
    const [billingTypeMappingState] = useBillingTypeMappingTracked();
    const billingTypeMappingVM = useBillingTypeMappingVM();
    const messageBarVM = useMessageBarVM();
    // const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);
    const [anainfoState] = useANAInfoTracked();
    const { allowUpdate } = anainfoState;
    const rightClickRef: any = createRef();
    // for right click menu with move after begin
    const [showMoveCursor, setShowMoveCursor] = useState<boolean>(false);
    const [allRows, setAllRows] = useState<BillingTypeMappingEntity[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [initialAllRows, setInitialAllRows] = useState<boolean>(true);

    const getAllRows = useCallback(() => {
        return allRows;
    }, [allRows]);

    const getSelectedRows = useCallback(() => {
        return billingTypeMappingState.selectedRows;
    }, [billingTypeMappingState.selectedRows]);

    // const getShowMoveCursor = useCallback(() => {
    //     return showMoveCursor;
    // }, [showMoveCursor]);
    //for right click menu with move after end

    // useEffect(() => {
    //     //const columnDefs = (INITIAL_BILLING_TYPE_MAPPING_COL_DEF?.slice());

    //     if (!billingTypeMappingState.selectedRows || billingTypeMappingState.selectedRows.length <= 0) {
    //         //gridRef.current?.gridRef.current.api?.setColumnDefs(columnDefs);
    //         if (!onTableSelectionClicked) {
    //             gridRef.current?.gridRef.current.api?.deselectAll();
    //         }
    //     }
    //     changeCursor("billing-type-mapping-table", getShowMoveCursor());
    // });

    // useEffect(() => {
    //     if (!onTableSelectionClicked) return;
    //     gridRef?.current?.gridRef.current.api?.deselectAll();
    //     changeCursor("billing-type-mapping-table", getShowMoveCursor());
    // }, [getShowMoveCursor, onTableSelectionClicked]);

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        // setOnTableSelectionClicked(true);
        billingTypeMappingVM.updateSelectedRows(selectedRows);
    }, [billingTypeMappingVM])

    // const handleRowDrag = useCallback((e: any, updatedRows: BillingTypeMappingEntity[], movedIndex: number, overIndex: number)=>{
    //     billingTypeMappingVM.onRowDrag(updatedRows);
    // },[billingTypeMappingVM])


    const handleRowDoubleClick = useCallback((entity: BillingTypeMappingEntity) => {
        // if(updatedRows.length > 0){
        //     messageBarVM.showError("Modified data has not been saved.Please save or refersh the data first."); 
        //     return;
        // }
        billingTypeMappingVM.onRowDoubleClick(entity);
    }, [billingTypeMappingVM])

    useEffect(() => {
        const handleRightClickMenu = (event: any) => {
            if (_.isEmpty(billingTypeMappingState.selectedRows) || !allowUpdate) {
                return;
            }
            event.preventDefault();
            rightClickRef.current.show(event);
        };
        document.getElementById('myDiv')?.addEventListener("contextmenu", handleRightClickMenu);

        return () => {
            document.getElementById('myDiv')?.removeEventListener("contextmenu", handleRightClickMenu);
        };
    }, [messageBarVM, rightClickRef, allowUpdate, billingTypeMappingState.selectedRows]);

    // for right click menu with move after begin
    const onRefreshRow = useCallback((newAllRows: any[]) => {
        setAllRows(newAllRows);
        billingTypeMappingVM.updateSelectedRows([]);
        setShowMoveCursor(true);
    }, [billingTypeMappingVM]);

    const onMoveCancel = useCallback(() => {
        setInitialAllRows(true);
        setAllRows(billingTypeMappingState.billingTypeMappingList);
        billingTypeMappingVM.updateSelectedRows([]);
        setShowMoveCursor(false);
    }, [billingTypeMappingState.billingTypeMappingList, billingTypeMappingVM]);

    const onSaveMove = useCallback(async (newAllRows: any[]) => {
        if (_.isEmpty(newAllRows)) return;

        setIsLoading(true);

        billingTypeMappingVM.onApply(newAllRows).then((res) => {
            if (!res || !res.success) {
                messageBarVM.showError('Move failed.');
                setInitialAllRows(true);
                setIsLoading(false);

                billingTypeMappingVM.updateSelectedRows([]);
                setShowMoveCursor(false);
            } else {
                billingTypeMappingVM.searchAllBillingTypeMappingList().then((data) => {
                    setInitialAllRows(true);
                    setIsLoading(false);

                    billingTypeMappingVM.updateSelectedRows([]);
                    setShowMoveCursor(false);
                }).catch((e) => {
                    setInitialAllRows(true);
                    setIsLoading(false);

                    billingTypeMappingVM.updateSelectedRows([]);
                    setShowMoveCursor(false);
                })
            }
        })
    }, [messageBarVM, billingTypeMappingVM]);

    const memoBillingTypeMappingTable = useMemo(() => {

        return (
            <>
                {(allowUpdate) && <RightClickMenuWithMoveAfter disabled={_.isEmpty(getSelectedRows())}
                    rightClickRef={rightClickRef} selectedRows={getSelectedRows()} allRows={getAllRows()}
                    onSaveMove={onSaveMove} onCancel={onMoveCancel} onRefreshRow={onRefreshRow}
                    showConfirmMove={showMoveCursor} priorityName="priority" />}
                <div id="myDiv">
                    <NbisTable
                        id='billing-type-mapping-table'
                        isNewColumnSetting={true}
                        columns={INITIAL_BILLING_TYPE_MAPPING_COL_DEF}
                        data={allRows ?? []}
                        showPaginator={false}
                        editable={false}
                        showAddIcon={false}
                        showDeleteButton={false}
                        showReloadIcon={false}
                        isScrollHighlighted={true}
                        selectionMode={false}
                        isRowHighligted={true}
                        handleSelectionChanged={handleSelectionChange}
                        onRowDoubleClick={(e: any, entity: BillingTypeMappingEntity) => handleRowDoubleClick(entity)}
                        gridHeight="customHeight"
                        customHeight="calc(100vh - 125px)"
                        ref={gridRef}
                        rowSelection={showMoveCursor ? "single" : "multiple"}
                        showCutCursor={showMoveCursor}
                    // isRowDrag={true}
                    // onRowDragged={handleRowDrag}
                    // onBodyScroll={(e: any) => changeCursor("billing-type-mapping-table", getShowMoveCursor())}
                    />
                </div>
            </>
        );
    }, [allRows, allowUpdate, getAllRows, getSelectedRows, handleRowDoubleClick, handleSelectionChange, onMoveCancel, onRefreshRow, onSaveMove, rightClickRef, showMoveCursor])

    useEffect(() => {
        if (initialAllRows && billingTypeMappingState.billingTypeMappingList && !_.isEmpty(billingTypeMappingState.billingTypeMappingList)) {
            setAllRows(billingTypeMappingState.billingTypeMappingList.map((billingTypeMappingEntity, index) => ({
                ...billingTypeMappingEntity,
                index: index || 0
            })));
            setInitialAllRows(false);
        }
    }, [allRows, initialAllRows, billingTypeMappingState.billingTypeMappingList]);

    return <><TableWrapper>
        {(isLoading) && <Loader Indicator="Spinner" size="Medium" />}
        {memoBillingTypeMappingTable}
    </TableWrapper>
    </>;
}

export default memo(BillingTypeMappingTablePanel);
